import { css, cx } from '@linaria/atomic';
import { ContentLoader, InlineNotification } from '@frontend/design-system';
import { usePaymentMethodSetupContext } from '../../../widgets/payment-method-setup/context/payment-method-setup-base.context';
import { GatewayRenderer } from '../../switches/gateway-renderer';
import { PaymentMethodSetupFormStripe } from './form-stripe';

const NoForm = () => null;

export const PaymentMethodSetupForm = ({ className }: { className?: string }) => {
  const { view, gateway, message, shouldShowLoading, loadingMessage } = usePaymentMethodSetupContext();

  return (
    <div className={cx(stackStyle, containerStyle, className)}>
      <ContentLoader show={shouldShowLoading} message={loadingMessage} />
      {view === 'notice' && <InlineNotification status='error'>{message}</InlineNotification>}
      {view === 'form' && (
        <GatewayRenderer
          activeGateway={gateway}
          stripeContent={PaymentMethodSetupFormStripe}
          stripeProps={{}}
          justifiContent={NoForm}
          justifiProps={{}}
        />
      )}
    </div>
  );
};

const stackStyle = css`
  display: flex;
  flex-direction: column;
  row-gap: var(--fabric-space-gap-md);
  column-gap: var(--fabric-space-gap-md);
`;

const containerStyle = css`
  position: relative;
`;
